import React from 'react'

interface DashboardShellProps {
  sidebar?: React.ReactNode
  header?: React.ReactNode
  children: React.ReactNode
}

export function DashboardShell({ sidebar, header, children }: DashboardShellProps) {
  return (
    <div className="min-h-screen bg-surface-base flex">
      {sidebar && (
        <aside className="w-64 flex-shrink-0 border-r border-surface-border bg-surface-raised">
          {sidebar}
        </aside>
      )}
      <div className="flex-1 flex flex-col min-w-0">
        {header && (
          <header className="h-14 border-b border-surface-border flex items-center px-6 bg-surface-raised flex-shrink-0">
            {header}
          </header>
        )}
        <main className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
    </div>
  )
}
